export default "__VITE_ASSET__BydBsMDi__"